//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import sr1 from './sr1';
import sr2 from './sr2';
export default {
  components: {
    sr1: sr1,
    sr2: sr2
  },
  data: function data() {
    var _this = this;

    return {
      activeName: '0'
    };
  },
  mounted: function mounted() {},
  methods: {}
};